import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: {
  title: string;
  category: string;
  image: null | string;
  updatedAt: string;
  content: string;
  combinedHTML: string;
  relAttributes: string;
} = {
  title: "",
  category: "",
  image: null,
  updatedAt: "",
  content: "",
  combinedHTML: "",
  relAttributes: "",
};

const blogEditorSlice = createSlice({
  name: "blog-editor-slice",
  initialState,
  reducers: {
    updateTitle: (state, action: PayloadAction<{ title: string }>) => {
      state.title = action.payload.title;
    },
    updateCategory: (state, action: PayloadAction<{ category: string }>) => {
      state.category = action.payload.category;
    },
    updateImage: (state, action: PayloadAction<{ image: string }>) => {
      state.image = action.payload.image;
    },
    updateContent: (state, action: PayloadAction<{ content: string }>) => {
      state.content = action.payload.content;
    },
    updateCombinedHTML: (
      state,
      action: PayloadAction<{ combinedHTML: string }>
    ) => {
      state.combinedHTML = action.payload.combinedHTML;
    },
    updateUpdatedAt: (state, action: PayloadAction<{ updatedAt: string }>) => {
      state.updatedAt = action.payload.updatedAt;
    },
  },
});

export const blogEditorActions = blogEditorSlice.actions;
export default blogEditorSlice;
